import { createReducer } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    customer: null,
    customers: [],
    success: false,
    error: null,
    message: null,
};

export const customerReducer = createReducer(initialState, (builder) => {
    builder
        // Customer Creation
        .addCase('customerCreateRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('customerCreateSuccess', (state, action) => {
            state.isLoading = false;
            state.customer = action.payload;
            state.success = true;
        })
        .addCase('customerCreateFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })
        // Fetch All Customers
        .addCase('getAllCustomersRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getAllCustomersSuccess', (state, action) => {
            state.isLoading = false;
            state.customers = action.payload;
        })
        .addCase('getAllCustomersFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        // Fetch Single Customer
        .addCase('getCustomerByIdRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getCustomerByIdSuccess', (state, action) => {
            state.isLoading = false;
            state.customer = action.payload;
        })
        .addCase('getCustomerByIdFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        // Edit Customer
        .addCase('editCustomerRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('editCustomerSuccess', (state, action) => {
            state.isLoading = false;
            state.customer = action.payload;
            state.success = true;
        })
        .addCase('editCustomerFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })
        // Update Customer Credit Information
        .addCase('updateCustomerCreditRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('updateCustomerCreditSuccess', (state, action) => {
            state.isLoading = false;
            state.customer = action.payload;
            state.success = true;
        })
        .addCase('updateCustomerCreditFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })
        // Delete Customer
        .addCase('deleteCustomerRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('deleteCustomerSuccess', (state, action) => {
            state.isLoading = false;
            state.message = action.payload;
        })
        .addCase('deleteCustomerFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        // Delete Customer Payment
        .addCase('deleteCustomerPaymentRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('deleteCustomerPaymentSuccess', (state, action) => {
            state.isLoading = false;
            state.customer = action.payload;
            state.success = true;
        })
        .addCase('deleteCustomerPaymentFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })
        // Print Credit Report
        .addCase('printCreditReportRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('printCreditReportSuccess', (state, action) => {
            state.isLoading = false;
            state.message = action.payload;
            state.success = true;
        })
        .addCase('printCreditReportFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })
        // Clear Errors
        .addCase('clearErrors', (state) => {
            state.error = null;
        })
        // Clear Success Messages
        .addCase('clearSuccess', (state) => {
            state.message = null;
            state.success = false;
        });
});